import Image from "next/image";

import type { MultiTextBanner } from "@repo/ui/types/cms/common";

interface PriceBannerProps {
  banner?: MultiTextBanner;
}

export function PriceBanner({ banner }: Readonly<PriceBannerProps>) {
  if (!banner) return null;

  const { icon, subtitle, subtitle_mobile, text, title } = banner;
  return (
    <div className="bg-brand-cyan rounded-md p-2 text-sm font-bold text-white md:mb-8 md:text-2xl">
      <div className="container mx-auto flex items-center justify-between gap-8 md:justify-center">
        <div className="flex items-center gap-2">
          <div className="relative h-5 w-5 md:h-8 md:w-8">
            {icon && (
              <Image src={icon} alt={title || "Banner Icon"} fill className="object-contain" />
            )}
          </div>
          {title && <span className="md:text-4xl">{title}</span>}
        </div>
        <div className="flex items-center gap-8">
          {subtitle && (
            <span className="hidden text-xs italic md:block md:text-lg">{subtitle}</span>
          )}
          {subtitle_mobile && (
            <span className="text-xs italic md:hidden md:text-lg">{subtitle_mobile}</span>
          )}
          {text && <span className="hidden md:flex">{text}</span>}
        </div>
      </div>
    </div>
  );
}
